import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="py-32 px-4 bg-terracotta text-white relative overflow-hidden" data-id="element-39">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-40" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-41" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-42">
        <FadeIn data-id="element-43">
          <div className="flex justify-center mb-8" data-id="element-44">
            <Sparkles className="w-10 h-10 text-white/80" data-id="element-45" />
          </div>

          <h2 className="text-4xl md:text-6xl font-serif mb-8 leading-tight" data-id="element-46">
            Descargá ahora el Plan
            <br data-id="element-47" />
            Pancita Desinflamada
          </h2>

          <p className="text-2xl md:text-3xl text-white/90 mb-12 font-serif" data-id="element-48">
            AR$ 9.300 — acceso inmediato
          </p>

          <div className="flex flex-col items-center gap-6 mb-12" data-id="element-49">
            <Button variant="secondary" withArrow className="w-full sm:w-auto text-xl px-12 py-6 bg-white text-terracotta hover:bg-cream shadow-xl shadow-black/10" data-id="element-50">
              Quiero mi plan
            </Button>
          </div>

          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-51">
            No necesitás castigarte para sentirte bien. Necesitás un plan que te
            cuide cuando estás cansada.
          </p>
        </FadeIn>
      </div>
    </section>;
}